















import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import StoreConfiguration from "@/admin/components/shared/StoreConfiguration.vue";

@Component({
  components: {
    Input,
    ErrorSummary,
    StoreConfiguration
  }
})
export default class HsaStoreConfiguration extends Vue {
  $router: VueRouter;
  $validator: Validator;
  $refs: any;

  featureFlagStore = useFeatureFlagStore();
  portalCustomizationStore = usePortalCustomizationStore();
  isSubmitting = false;
  isLoaded = false;

  originalStoreInfo = {};

  @Prop() partnerId: number;

  mounted () {
    this.onPartnerIdChanged(this.partnerId);
    this.initialize();
  }

  @Watch("partnerId")
  onPartnerIdChanged (partnerId) {
    this.portalCustomizationStore.unsetHsaStoreLoaded();
    this.portalCustomizationStore.getHsaStoreInfo(partnerId);
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }

  @Watch("portalCustomizationStore.isHsaStoreInfoLoaded")
  initialize () {
    if (this.portalCustomizationStore.isHsaStoreInfoLoaded) {
      this.originalStoreInfo = { ...this.portalCustomizationStore.hsaStoreInfo };
      this.$refs.storeConfigurationRef.storeInfo = this.portalCustomizationStore.hsaStoreInfo;
      this.isLoaded = true;
    }
  }

  submit () {
    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }

          this.isSubmitting = true;
          this.portalCustomizationStore.saveHsaStoreInfo({
                partnerId: this.partnerId,
                info: this.$refs.storeConfigurationRef.storeInfo
              })
              .then(() => this.isSubmitting = false);
        });
  }
}
